import styled, { css } from "styled-components";
import { FlexBox, FInter, Colors, RectangularButtonFilled } from "@brg/ui";
import { LayoutConst } from 'core/modules';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { NewCategoryButtonsContainer, NewCategoryInputsContainer, SmallLabel } from "_deziiign/main/pages/MainTagAdminPage/styles";

export const ActionsWrapper = styled(FlexBox)<{ hide?: boolean }>`
    flex-flow: column;
    margin: 0;

    ${({ hide }) => hide && css`display: none; `};
    @media(max-width: ${LayoutConst.screen.md}px) {
        margin: 12px 0 0 0;
    }

    .checkbox-noproject {
      &:hover {
        background-color: transparent;
      }
    }
`;

export const NoProjectWrapper = styled(FlexBox)`
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  width: 1152px;

  color: ${Colors.galBlack47};
  font-size: 30px;
  line-height: 40px;

  @media (max-width:${LayoutConst.screen.l_12}px) {
    width: 940px;
    margin-top: 56px;
    font-size: 22px;
    line-height: 28px;
  }

  @media (max-width: 940px) {
    width: 712px;
  }
  @media (max-width: 744px) {
    width: calc(100vw - 20px);
    margin-top: 40px;
    font-size: 17px;
    line-height: 22px;
  }
`

export const ProjectTabItem = styled.div<{ isActive?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({isActive}) => isActive ? Colors.galBlack100 : Colors.galBlack47};
  cursor: pointer;
`

export const ModalContainer = styled(FlexBox)`
    width: 100%;
    position: relative;
  ::-webkit-scrollbar {
      width: 2px; /* ширина scrollbar */
      height: 2px;
  }
  ::-webkit-scrollbar-track {
      background: white; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
      background: black;
      border: 1px solid rgba(254, 254, 254, 0.13);
  }
`;

export const ActionBottomButtons = styled(FlexBox)`
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    justify-content: flex-end;
    z-index: 9999;
    background-color: ${Colors.geoWhite100};
    padding-top: 8px;
    padding-bottom: 8px;

    ${SendProjectButton} {
        height: 35px;
        margin-right: 10px;
        font-size: 13px;
        line-height: 18px;
        font-weight: 700;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      ${SendProjectButton} {
        width: calc(100% - 20px);
        max-width: none;
        min-width: auto;
      }
    }
    
`

export const ExamFooterButtons = styled(FlexBox)`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    justify-content: center;
    z-index: 9999;
    background-color: ${Colors.galBlack5};
    padding: 16px 20px;
    border-top: 1px solid ${Colors.galBlack10});

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      padding: 12px 16px;
    }
`

export const ProjectsCount = styled(FInter.Text)`
  color: ${({ theme }) => theme.sendProjectsModal.countText};
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.md}px) {
      font-size: 13px;
      line-height: 18px;
  }

`;

export const MainTitle = styled(FInter.SectionTitle)`
    color: ${({ theme }) => theme.sendProjectsModal.title};
    letter-spacing: -0.02em;
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 30px;
        line-height: 40px;
    }
`;
export const ExamTitle = styled(FInter.SectionTitle)`
   font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 133.333% */
  letter-spacing: -0.6px;
  color: #151514;
  margin-bottom: 16px;

`;

export const DescTitle = styled(FInter.SectionTitle)`
    color: ${Colors.galBlack47};
    letter-spacing: -0.02em;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;

    @media(max-width: ${LayoutConst.screen.m}px) {
      font-size: 15px;
      line-height: 20px;
    }
  
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 13px;
      line-height: 16px;
    }

`;

export const ActionsTitle = styled(FlexBox)`
    width: 100%;
    margin-bottom: 24px;
    flex-flow: row;
    place-items: center;
    align-items: flex-start;

    svg:not(.close-modal-mobile) {
      path {
        fill: #909090;
        transition: fill 0.2s;
      }
      &:hover {
        path {
          fill: #151514;
          transition: fill 0.2s;
        }
      }
      @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 40px;
        height: 40px;
      }
    }

    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: 24px;
    }

  @media (max-width: ${LayoutConst.screen.m}px) {
    row-gap: 16px;
    align-items: flex-start;
    margin-bottom: 32px;
    justify-content: space-between;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: 24px;
  }
`;

export const ActionsColumnBlock = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    justify-content: center;
    place-items: center;
`;

export const CardsGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(8, 123px);
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 50vh;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    gap: 16px;
    grid-template-columns: repeat(4, 166px);
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    gap: 10px;
    grid-template-columns: repeat(2, calc(50vw - 15px));
  }

`

export const ImageCardsGrid = styled(CardsGrid)`
  width: 574px;
  gap: 16px;
  grid-template-columns: repeat(4, 127px);
  grid-template-rows: 127px;
  min-height: 50vh;
  overflow-x: hidden;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 574px;
    gap: 16px;
    grid-template-columns: repeat(4, 127px);
    grid-template-rows: 127px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    grid-template-columns: repeat(5, 127px);
    grid-template-rows: 127px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: calc(33.3vw - 15px);
  }

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #FEFEFE;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #909090;
  }
`

export const Tab = styled(FInter.SectionTitle)<{active?: boolean}>`
    color: ${({active}) => active ? Colors.galBlack100 : Colors.galBlack47};
    letter-spacing: -0.02em;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    cursor: pointer;
    
    @media(max-width: ${LayoutConst.screen.md}px) {
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 13px;
      line-height: 16px;
    }

`;

export const SendImageButtonContainer = styled(FlexBox)`
  background-color: #fefefe;
  height: 56px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 10px;
`;

export const SendImagesButton = styled(SendProjectButton)`
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 48px!important;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      width: 180px;
      height: 38px !important;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      width: 100%;
      height: 36px !important;

      span {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
      }
    }



`;

export const CollectionDropdown = styled(FlexBox)`
  width: 100%;
  flex-flow: column;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 100%;
  }

  .brg-input__control {
    background: rgba(242, 242, 242, 1) !important;
    border: none!important;
    cursor: pointer;

    &:hover {
      background: rgba(242, 242, 242, 1) ;
    }
  }
  .brg-input__single-value {
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(21, 21, 20, 1);
    letter-spacing: -0.02em;
  }

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({theme}) => theme.competition.input.inputText} !important;
    }
  }

  .brg-input__indicators {
    align-items: start;
  }
  
  .brg-input__indicator {
    padding-top: 14px;
    margin-right: 0;
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.inputText} !important;;
      }
    }
  }

  .brg-input__control--menu-is-open  {
    .brg-input__indicator {
      padding-top: 0px;
    }
  }

  .brg-input__menu {
    background: rgba(242, 242, 242, 1);
    * {
      font-size: 17px;
      line-height: 22px;
      font-weight: 600;
      color: rgb(112, 112, 111);
      letter-spacing: -0.02em;
      cursor: pointer;
    }
  }

  .brg-input__option {
    background-color: rgba(242, 242, 242, 1) !important;
    &:hover {
      background-color: rgba(231, 231, 231, 1) !important;
    }
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.inputText} !important;
      }
    }
  }


    @media(max-width: ${LayoutConst.screen.md}px) {
      .brg-input__single-value {
        font-size: 15px;
        line-height: 20px;
      }

      .brg-input__menu {
        * {
          font-size: 15px;
          line-height: 20px;
          font-weight: 600;
          color: rgba(112, 112, 111, 1);
        }
      }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      .brg-input__single-value {
        font-size: 13px;
        line-height: 16px;
      }
      .brg-input__menu {
        * {
          font-size: 13px;
          line-height: 16px;
          font-weight: 600;
          color: rgba(112, 112, 111, 1);
        }
      }
    }
`

export const CompetitionSubtitle = styled.div`
  font-family: 'Inter';
  font-size: 17px;
  line-height: 22px;
  color: ${Colors.galBlack47};
  margin-top: 8px !important;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: 16px !important;
  }
`;

export const ModalSearchWrapper = styled(FlexBox)`
  height: 46px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;

export const TagsTitle = styled.div<{isExam?: boolean}>`
  font-family: 'Inter';
  text-align: center;

  ${({isExam}) => isExam ? css`
    max-width: 480px;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    color: #151514;
    margin-bottom: 40px;
  ` : css`
    color: ${({ theme }) => theme.competition.modal.tagsTitle.color};
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 23px;
      line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 20px;
      line-height: 25px;
      max-width: 268px;
      text-align: center;
    }
  `}
`;
export const CreateButton = styled(RectangularButtonFilled)`
    height: 48px;
    width: 228px;

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
        width: 100%;
        min-width: 100%;
        height: 40px !important;
    }
`;

export const DeselectButton = styled(RectangularButtonFilled)`
    height: 50px;
    padding: 13px 48px;
    background-color: transparent;
    border: 1px solid ${Colors.galBlack47};
    border-radius: 3px;
    color: ${Colors.galBlack100};


    &:hover {
        background-color: ${Colors.galBlack47};
        color: ${Colors.geoWhite100};
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
        width: 100%;
        min-width: 100%;
        height: 40px !important;
    }
`;

export const SubmitButton = styled(RectangularButtonFilled)`
    height: 50px;
    padding: 13px 48px;
    background-color: ${Colors.galBlack100};
    border: 1px solid ${Colors.galBlack100};
    color: ${Colors.geoWhite100};

    &:hover {
        background-color: ${Colors.galBlack47};
        border-color: ${Colors.galBlack47};
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
        width: 100%;
        min-width: 100%;
        height: 40px !important;
    }
`;

export const SelectedProjectWrapper = styled(FlexBox)`
    position: relative;
    max-width: 1152px;
    margin-left: auto;
    margin-right: auto;
    width: 1152px;
    
    @media(max-width: ${LayoutConst.screen.l_12}px) {
      max-width: ${LayoutConst.container.m}px;
      width: ${LayoutConst.container.m}px;
      min-width: ${LayoutConst.container.m}px;
    }
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      max-width: ${LayoutConst.container.xs}px;
      width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;
    }
    
    @media(max-width: ${LayoutConst.screen.s -1}px) {
      padding: 0 10px;
      width: 100%;
      min-width: auto;
      max-width: none;
      margin: 0;
    }
`;
export const SelectedProjectName = styled.div`
    font-family: 'Inter';
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;
    color: ${Colors.galBlack100};
    letter-spacing: -0.02em;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        max-width: 200px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
        max-width: 150px;
    }
`;
export const SelectedProjectDesc = styled.div`
    font-family: 'Inter';
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #343434;
    letter-spacing: -0.02em;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
        max-width: 200px;
    }
`;

export const TagsLabel = styled.div`
  font-size: 17px;
  line-height: 22px;
  margin: 16px 0;
  color: ${({ theme }) => theme.competition.modal.tagsTitle.color};

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 12px 0;
  }

  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    margin: 16px 0;
  }
`;

export const SendButton = styled(SendProjectButton)`
  width: 185px;
  height: 46px;
  max-width: 185px;
  min-width: 185px;

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 175px;
    min-width: 175px;
    width: 175px;
    height: 44px;
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    max-width: 128px;
    min-width: 128px;
    width: 128px;
    height: 38px;
  }
`;

export const CreateProject = styled.div`
  font-family: 'Inter';
  font-size: 17px;
  line-height: 22px;
  color: #909090;
  margin-bottom: 24px;

  @media(max-width: ${LayoutConst.screen.m}px) {
    text-align: center;
  }
`;

export const CollectionModalInputWrapper = styled(FlexBox)`
  width: 522px;

  .brg-input__control {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    flex-flow: row;
    max-width: ${LayoutConst.container.xs}px;

    .brg-input__control {
      max-width: 344px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    flex-flow: column;

    .brg-input__control {
      max-width: none;
    }
  }

`;

export const CollectionModalLabel = styled.span`
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  color: #909090;
`;

export const CollectionEditContainer = styled(NewCategoryInputsContainer)`
  border: none;
  padding: 16px 0 24px 0;
  input {
    background: rgba(242,242,242,1);
    color: #151514;
    border: 1px solid transparent;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    ::placeholder {
      color: rgba(182, 182, 181, 1);
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
    }

    :hover {
      ::placeholder {
        color: rgba(182, 182, 181, 1);
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
      }
    }
  }

  .label {
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    color: #151514;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    padding: 0;

    input {
      font-size: 15px;
      line-height: 20px;
    }

    .label {
      font-size: 20px;
      line-height: 25px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    input {
      font-size: 13px;
      line-height: 16px;

      ::placeholder {
        font-size: 13px;
        line-height: 16px;
      }
    }
  }
`;

export const CollectionEditButtonsContainer = styled(NewCategoryButtonsContainer)`
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      div {
        min-width: 100px;
        font-size: 15px;
        line-height: 20px;
        height: 36px;
      }
    }

`;

export const Label = styled(SmallLabel)`
  font-size: 17px;
  line-height: 22px;
  margin-bottom: 0;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const SecondTitle = styled.div`
  font-size: 17px;
  line-height: 22px;
  margin-bottom: 0;
  letter-spacing: -0.02em;
  color: #909090;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;
import styled, { css } from "styled-components";
import { FlexBox, FInter, Colors, RectangularButtonFilled } from "@brg/ui";
import { LayoutConst } from 'core/modules';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { NewCategoryButtonsContainer, NewCategoryInputsContainer, SmallLabel } from "_deziiign/main/pages/MainTagAdminPage/styles";

export const ActionsWrapper = styled(FlexBox)<{ hide?: boolean }>`
    flex-flow: column;
    margin: 0;

    ${({ hide }) => hide && css`display: none; `};
    @media(max-width: ${LayoutConst.screen.md}px) {
        margin: 12px 0 0 0;
    }

    .checkbox-noproject {
      &:hover {
        background-color: transparent;
      }
    }
`;

export const NoProjectWrapper = styled(FlexBox)`
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  width: 1152px;

  color: ${Colors.galBlack47};
  font-size: 30px;
  line-height: 40px;

  @media (max-width:${LayoutConst.screen.l_12}px) {
    width: 940px;
    margin-top: 56px;
    font-size: 22px;
    line-height: 28px;
  }

  @media (max-width: 940px) {
    width: 712px;
  }
  @media (max-width: 744px) {
    width: calc(100vw - 20px);
    margin-top: 40px;
    font-size: 17px;
    line-height: 22px;
  }
`

export const ProjectTabItem = styled.div<{ isActive?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${({isActive}) => isActive ? Colors.galBlack100 : Colors.galBlack47};
  cursor: pointer;
`

export const ModalContainer = styled(FlexBox)`
    width: 100%;
    position: relative;
  ::-webkit-scrollbar {
      width: 2px; /* ширина scrollbar */
      height: 2px;
  }
  ::-webkit-scrollbar-track {
      background: white; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
      background: black;
      border: 1px solid rgba(254, 254, 254, 0.13);
  }
`;

export const ActionBottomButtons = styled(FlexBox)`
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    justify-content: flex-end;
    z-index: 9999;
    background-color: ${Colors.geoWhite100};
    padding-top: 8px;
    padding-bottom: 8px;

    ${SendProjectButton} {
        height: 35px;
        margin-right: 10px;
        font-size: 13px;
        line-height: 18px;
        font-weight: 700;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      ${SendProjectButton} {
        width: calc(100% - 20px);
        max-width: none;
        min-width: auto;
      }
    }
    
`

export const ExamFooterButtons = styled(FlexBox)`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    justify-content: center;
    z-index: 9999;
    background-color: ${Colors.galBlack5};
    padding: 16px 20px;
    border-top: 1px solid ${Colors.galBlack10});

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      padding: 12px 16px;
    }
`

export const ProjectsCount = styled(FInter.Text)`
  color: ${({ theme }) => theme.sendProjectsModal.countText};
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.md}px) {
      font-size: 13px;
      line-height: 18px;
  }

`;

export const MainTitle = styled(FInter.SectionTitle)`
    color: ${({ theme }) => theme.sendProjectsModal.title};
    letter-spacing: -0.02em;
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 30px;
        line-height: 40px;
    }
`;
export const ExamTitle = styled(FInter.SectionTitle)`
   font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 133.333% */
  letter-spacing: -0.6px;
  color: #151514;
  margin-bottom: 16px;

`;

export const DescTitle = styled(FInter.SectionTitle)`
    color: ${Colors.galBlack47};
    letter-spacing: -0.02em;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;

    @media(max-width: ${LayoutConst.screen.m}px) {
      font-size: 15px;
      line-height: 20px;
    }
  
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 13px;
      line-height: 16px;
    }

`;

export const ActionsTitle = styled(FlexBox)`
    width: 100%;
    margin-bottom: 24px;
    flex-flow: row;
    place-items: center;
    align-items: flex-start;

    svg:not(.close-modal-mobile) {
      path {
        fill: #909090;
        transition: fill 0.2s;
      }
      &:hover {
        path {
          fill: #151514;
          transition: fill 0.2s;
        }
      }
      @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 40px;
        height: 40px;
      }
    }

    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin-bottom: 24px;
    }

  @media (max-width: ${LayoutConst.screen.m}px) {
    row-gap: 16px;
    align-items: flex-start;
    margin-bottom: 32px;
    justify-content: space-between;
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: 24px;
  }
`;

export const ActionsColumnBlock = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    justify-content: center;
    place-items: center;
`;

export const CardsGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(8, 123px);
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 50vh;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    gap: 16px;
    grid-template-columns: repeat(4, 166px);
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    gap: 10px;
    grid-template-columns: repeat(2, calc(50vw - 15px));
  }

`

export const ImageCardsGrid = styled(CardsGrid)`
  width: 574px;
  gap: 16px;
  grid-template-columns: repeat(4, 127px);
  grid-template-rows: 127px;
  min-height: 50vh;
  overflow-x: hidden;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 574px;
    gap: 16px;
    grid-template-columns: repeat(4, 127px);
    grid-template-rows: 127px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    grid-template-columns: repeat(5, 127px);
    grid-template-rows: 127px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: calc(33.3vw - 15px);
  }

  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #FEFEFE;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #909090;
  }
`

export const Tab = styled(FInter.SectionTitle)<{active?: boolean}>`
    color: ${({active}) => active ? Colors.galBlack100 : Colors.galBlack47};
    letter-spacing: -0.02em;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    cursor: pointer;
    
    @media(max-width: ${LayoutConst.screen.md}px) {
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 13px;
      line-height: 16px;
    }

`;

export const SendImageButtonContainer = styled(FlexBox)`
  background-color: #fefefe;
  height: 56px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 10px;
`;

export const SendImagesButton = styled(SendProjectButton)`
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 48px!important;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      width: 180px;
      height: 38px !important;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      width: 100%;
      height: 36px !important;

      span {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
      }
    }



`;

export const CollectionDropdown = styled(FlexBox)`
  width: 100%;
  flex-flow: column;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 100%;
  }

  .brg-input__control {
    background: rgba(242, 242, 242, 1) !important;
    border: none!important;
    cursor: pointer;

    &:hover {
      background: rgba(242, 242, 242, 1) ;
    }
  }
  .brg-input__single-value {
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(21, 21, 20, 1);
    letter-spacing: -0.02em;
  }

  .brg-input__menu-list {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({theme}) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({theme}) => theme.competition.input.inputText} !important;
    }
  }

  .brg-input__indicators {
    align-items: start;
  }
  
  .brg-input__indicator {
    padding-top: 14px;
    margin-right: 0;
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.inputText} !important;;
      }
    }
  }

  .brg-input__control--menu-is-open  {
    .brg-input__indicator {
      padding-top: 0px;
    }
  }

  .brg-input__menu {
    background: rgba(242, 242, 242, 1);
    * {
      font-size: 17px;
      line-height: 22px;
      font-weight: 600;
      color: rgb(112, 112, 111);
      letter-spacing: -0.02em;
      cursor: pointer;
    }
  }

  .brg-input__option {
    background-color: rgba(242, 242, 242, 1) !important;
    &:hover {
      background-color: rgba(231, 231, 231, 1) !important;
    }
    svg {
      path {
        fill: ${({theme}) => theme.competition.input.inputText} !important;
      }
    }
  }


    @media(max-width: ${LayoutConst.screen.md}px) {
      .brg-input__single-value {
        font-size: 15px;
        line-height: 20px;
      }

      .brg-input__menu {
        * {
          font-size: 15px;
          line-height: 20px;
          font-weight: 600;
          color: rgba(112, 112, 111, 1);
        }
      }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      .brg-input__single-value {
        font-size: 13px;
        line-height: 16px;
      }
      .brg-input__menu {
        * {
          font-size: 13px;
          line-height: 16px;
          font-weight: 600;
          color: rgba(112, 112, 111, 1);
        }
      }
    }
`

export const CompetitionSubtitle = styled.div`
  font-family: 'Inter';
  font-size: 17px;
  line-height: 22px;
  color: ${Colors.galBlack47};
  margin-top: 8px !important;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: 16px !important;
  }
`;

export const ModalSearchWrapper = styled(FlexBox)`
  height: 46px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 40px;
  }
`;

export const TagsTitle = styled.div<{isExam?: boolean}>`
  font-family: 'Inter';
  text-align: center;

  ${({isExam}) => isExam ? css`
    max-width: 480px;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    color: #151514;
    margin-bottom: 40px;
  ` : css`
    color: ${({ theme }) => theme.competition.modal.tagsTitle.color};
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 23px;
      line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      font-size: 20px;
      line-height: 25px;
      max-width: 268px;
      text-align: center;
    }
  `}
`;
export const CreateButton = styled(RectangularButtonFilled)`
    height: 48px;
    width: 228px;

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
        width: 100%;
        min-width: 100%;
        height: 40px !important;
    }
`;

export const DeselectButton = styled(RectangularButtonFilled)`
    height: 50px;
    padding: 13px 48px;
    background-color: transparent;
    border: 1px solid ${Colors.galBlack47};
    border-radius: 3px;
    color: ${Colors.galBlack100};


    &:hover {
        background-color: ${Colors.galBlack47};
        color: ${Colors.geoWhite100};
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
        width: 100%;
        min-width: 100%;
        height: 40px !important;
    }
`;

export const SubmitButton = styled(RectangularButtonFilled)`
    height: 50px;
    padding: 13px 48px;
    background-color: ${Colors.galBlack100};
    border: 1px solid ${Colors.galBlack100};
    color: ${Colors.geoWhite100};

    &:hover {
        background-color: ${Colors.galBlack47};
        border-color: ${Colors.galBlack47};
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin-top: 16px;
        width: 100%;
        min-width: 100%;
        height: 40px !important;
    }
`;

export const SelectedProjectWrapper = styled(FlexBox)`
    position: relative;
    max-width: 1152px;
    margin-left: auto;
    margin-right: auto;
    width: 1152px;
    
    @media(max-width: ${LayoutConst.screen.l_12}px) {
      max-width: ${LayoutConst.container.m}px;
      width: ${LayoutConst.container.m}px;
      min-width: ${LayoutConst.container.m}px;
    }
    
    @media (max-width: ${LayoutConst.screen.m}px) {
      max-width: ${LayoutConst.container.xs}px;
      width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;
    }
    
    @media(max-width: ${LayoutConst.screen.s -1}px) {
      padding: 0 10px;
      width: 100%;
      min-width: auto;
      max-width: none;
      margin: 0;
    }
`;
export const SelectedProjectName = styled.div`
    font-family: 'Inter';
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;
    color: ${Colors.galBlack100};
    letter-spacing: -0.02em;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
        max-width: 200px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
        max-width: 150px;
    }
`;
export const SelectedProjectDesc = styled.div`
    font-family: 'Inter';
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #343434;
    letter-spacing: -0.02em;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
        max-width: 200px;
    }
`;

export const TagsLabel = styled.div`
  font-size: 17px;
  line-height: 22px;
  margin: 16px 0;
  color: ${({ theme }) => theme.competition.modal.tagsTitle.color};

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    margin: 12px 0;
  }

  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    margin: 16px 0;
  }
`;

export const SendButton = styled(SendProjectButton)`
  width: 185px;
  height: 46px;
  max-width: 185px;
  min-width: 185px;

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 175px;
    min-width: 175px;
    width: 175px;
    height: 44px;
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    max-width: 128px;
    min-width: 128px;
    width: 128px;
    height: 38px;
  }
`;

export const CreateProject = styled.div`
  font-family: 'Inter';
  font-size: 17px;
  line-height: 22px;
  color: #909090;
  margin-bottom: 24px;

  @media(max-width: ${LayoutConst.screen.m}px) {
    text-align: center;
  }
`;

export const CollectionModalInputWrapper = styled(FlexBox)`
  width: 522px;

  .brg-input__control {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    flex-flow: row;
    max-width: ${LayoutConst.container.xs}px;

    .brg-input__control {
      max-width: 344px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    flex-flow: column;

    .brg-input__control {
      max-width: none;
    }
  }

`;

export const CollectionModalLabel = styled.span`
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  color: #909090;
`;

export const CollectionEditContainer = styled(NewCategoryInputsContainer)`
  border: none;
  padding: 16px 0 24px 0;
  input {
    background: rgba(242,242,242,1);
    color: #151514;
    border: 1px solid transparent;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    ::placeholder {
      color: rgba(182, 182, 181, 1);
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
    }

    :hover {
      ::placeholder {
        color: rgba(182, 182, 181, 1);
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
      }
    }
  }

  .label {
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    color: #151514;
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    padding: 0;

    input {
      font-size: 15px;
      line-height: 20px;
    }

    .label {
      font-size: 20px;
      line-height: 25px;
    }
  }

  @media(max-width: ${LayoutConst.screen.s -1 }px) {
    input {
      font-size: 13px;
      line-height: 16px;

      ::placeholder {
        font-size: 13px;
        line-height: 16px;
      }
    }
  }
`;

export const CollectionEditButtonsContainer = styled(NewCategoryButtonsContainer)`
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      div {
        min-width: 100px;
        font-size: 15px;
        line-height: 20px;
        height: 36px;
      }
    }

`;

export const Label = styled(SmallLabel)`
  font-size: 17px;
  line-height: 22px;
  margin-bottom: 0;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const SecondTitle = styled.div`
  font-size: 17px;
  line-height: 22px;
  margin-bottom: 0;
  letter-spacing: -0.02em;
  color: #909090;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;
